import {BaseElement} from "back/commons/basis";
import {JSX} from "lib/commons/xml/dom";
import {OHistoLineInit} from "back/wsp/widgets/diff/histoLine";

export class HistoLine extends BaseElement {

	protected _initialize(init: OHistoLineInit): void {
		this._attach(this.localName, init, <div>HistoBar...</div>);
	}
}